import {useQuery} from '@tanstack/react-query';
import {useEffect, useState} from 'react';
import {showSnackbar} from '../../../api/snackbarSlice';
import {useDispatch, useSelector} from 'react-redux';
import {apiClient} from '../../../utils/axios';
import {AxiosError} from 'axios';

export const fetchSalesInvoice = async (query) => {
    const { data } = await apiClient.get(`/sales-invoices/${query.queryKey[1]}`);
    return data;
};

export const fetchPurchaseInvoice = async (query) => {
    const { data } = await apiClient.get(`/purchase-invoices/${query.queryKey[1]}`);
    return data;
};

export const useGetInvoiceHandler = (id, isPurchase = false) => {
    const dispatch = useDispatch();
    const [invoice, setInvoice] = useState(undefined);

    const {
        data: fetchedData,
        isLoading,
        isFetching,
        isError,
        error,
    } = useQuery({
        queryKey: [isPurchase ? 'purchase-invoices' : 'sales-invoices', id],
        queryFn: isPurchase ? fetchPurchaseInvoice : fetchSalesInvoice,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchOnMount: 'always',
        retry: 3,
    });

    useEffect(() => {
        if (fetchedData) {
            setInvoice(fetchedData);
        }
    }, [fetchedData]);

    useEffect(() => {
        if (isError) {
            if (error instanceof AxiosError) {
                if (error.status) {
                    dispatch(showSnackbar({message: error.response.data.message, severity: 'error'}));
                } else {
                    dispatch(showSnackbar({message: error.message, severity: 'error'}));
                }
            } else {
                dispatch(showSnackbar({message: JSON.stringify(error), severity: 'error'}));
            }
        }
    }, [dispatch, error, isError]);

    return {
        invoice: invoice,
        isLoading,
    };
};
